import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	archivedAndPendingComponents: {
		id: 'search-page.filters.names.archivedAndPendingComponents',
		defaultMessage: 'Show archived/pending components',
		description: 'Label for filtering by archived and pending components',
	},
});
